module.exports = __webpack_public_path__ + "static/media/m-kkaebangjung.d9d1fda8.jpg";